
import React from 'react';
import { cn } from '@/lib/utils';
import FeatureCard from './FeatureCard';

type Feature = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

type FeaturesProps = {
  title?: string;
  subtitle?: string;
  features: Feature[];
  className?: string;
  columns?: 2 | 3 | 4;
};

const Features = ({ title, subtitle, features, className, columns = 2 }: FeaturesProps) => {
  const columnsClass = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-2 lg:grid-cols-4',
  }[columns];

  return (
    <section className={cn("py-20 md:py-28 relative", className)}>
      {/* Decorative background element */}
      <div className="absolute inset-0 bg-gold-gradient opacity-5"></div>
      
      <div className="container mx-auto px-6 sm:px-8 relative z-10"> {/* Increased padding */}
        {title && (
          <h2 className="section-title-centered after:bg-gold text-3xl md:text-4xl lg:text-5xl mb-10">
            {title}
          </h2>
        )}
        
        {subtitle && (
          <p className="text-lg text-center max-w-3xl mx-auto mb-14 font-lora px-4">
            {subtitle}
          </p>
        )}
        
        <div className={`grid grid-cols-1 ${columnsClass} gap-x-10 gap-y-12 mt-12`}> {/* Increased gap */}
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              className="animate-slide-in p-8" /* Increased padding */
              style={{ animationDelay: `${index * 0.2}s` }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
